import { useQuery } from "@tanstack/react-query";
import { PeopleSearchCriteria, PeopleSearchSort, criteriaHash } from "@/types/peopleSearch";
import { fetchPeopleSearchPage, resolvePeopleSearch } from "@/utils/peopleSearchExecutor";

// Results for the applied criteria. The resolve step reuses the exact query
// key populated by usePeopleSearchCount, so Apply after a preview is instant.
// Sort only affects the page fetch, never the resolve.
export function usePeopleSearchResults(applied: PeopleSearchCriteria, page: number, enabled: boolean, sort: PeopleSearchSort) {
	const hash = criteriaHash(applied);

	const resolveQuery = useQuery({
		queryKey: ['people-search-resolve', hash],
		queryFn: () => resolvePeopleSearch(applied),
		staleTime: 60 * 1000,
		enabled,
	});

	const pageQuery = useQuery({
		queryKey: ['people-search-page', hash, page, sort],
		queryFn: () => fetchPeopleSearchPage(applied, resolveQuery.data!, page, sort),
		staleTime: 60 * 1000,
		enabled: enabled && !!resolveQuery.data,
	});

	const error = resolveQuery.error || pageQuery.error;

	const refetch = () => {
		if (resolveQuery.error)
			resolveQuery.refetch();
		else
			pageQuery.refetch();
	};

	return {
		rows: pageQuery.data?.rows ?? [],
		total: pageQuery.data?.total ?? resolveQuery.data?.count ?? 0,
		isLoading: enabled && (resolveQuery.isLoading || pageQuery.isLoading),
		error,
		isError: !!error,
		refetch,
	};
}
